import * as React from "react";

import "./front-template-viewer.scss";

import {cs}             from "@Common/react/chain-services";
import {EnlargedView}   from "../../../../../common/enlarged-view/enlarged-view";
import {ImageViewer}    from "./image-viewer/image-viewer";

export const FrontTemplateViewer = ({
    activeKey=undefined,
    next,
    label,
    images,
    view,
    gallery,
    loading=false,
}) => cs(
    ["enlargedView", ({}, next) => EnlargedView({
        images,
        gallery,
        onChangeView: (key) => view.onChange({...view.value, key: key}),
        viewing: view.value.key,
        next,
    })],
    ({enlargedView}) => next({
        render: () => (
            <div className="front-template-viewer-28e">
                <div className="header">
                    <div className="title">
                        {label}
                    </div>
                </div>
                {ImageViewer({
                    images: images?.map((img, i) => ({
                        ...img,
                        onClick: () => img.onClick ? img.onClick() : view.onChange({key: i}),
                    })),
                    gallery,
                    loading,
                    onEnlarge: () =>
                    {
                        view.onChange({key: (activeKey ?? view.value.key)});
                        enlargedView.show();
                    },
                    viewing: activeKey ?? view.value.key,
                })}
            </div>
        ),
    }),
);

export const decreaseGallery = (gallery, images, viewing) => {
    const imageIndexMax = images?.length - 1 || 0
    const previous = viewing > 0 ? viewing - 1 : imageIndexMax
    const gallerySize = gallery.value.size

    if(previous === imageIndexMax) {
        const end = imageIndexMax
        const start = end - gallerySize + 1
        gallery.onChange({...gallery.value, start, end})
        return
    }

    if(previous < gallery.value.start) {
        const start = gallery.value.start - 1
        const end = gallery.value.end - 1
        gallery.onChange({...gallery.value, start, end})
    }
}

export const increaseGallery = (gallery, images, viewing) => {
    const imageIndexMax = images?.length - 1 || 0
    const subsequent = viewing < imageIndexMax ? viewing + 1 : 0
    const gallerySize = gallery.value.size

    if(subsequent === 0) {
        const start = 0
        const end = gallerySize - 1
        gallery.onChange({...gallery.value, start, end})
        return
    }

    if(subsequent > gallery.value.end) {
        const start = gallery.value.start + 1
        const end = gallery.value.end + 1
        gallery.onChange({...gallery.value, start, end})
    }
}
